import { Type } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getScheduleEventUrl } from 'src/app/common/utils/url';
import { Alert, EventAlertEntity, PriorityConfig } from '../../models/alert';
import { RelatedEventComponent } from '../alert-details/related-event/related-event.component';
import { AlertPrimaryAction, AlertViewModel } from './alert.view-model';

export abstract class EventAlertViewModel extends AlertViewModel<EventAlertEntity> {
  constructor(
    alert: Alert<EventAlertEntity>,
    protected readonly translateService: TranslateService,
    priorityConfig: PriorityConfig | null = null,
  ) {
    super(alert, priorityConfig);
  }

  override get relatedComponentType(): Type<unknown> | null {
    return RelatedEventComponent;
  }

  override get primaryAction(): AlertPrimaryAction | null {
    const eventId = this.entity?._id;
    if (!eventId) {
      return null;
    }

    return {
      label: this.translateService.instant('Go to event'),
      icon: 'open_in_new',
      execute: () => window.open(getScheduleEventUrl(eventId), '_blank'),
    };
  }
}
